/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customer_Badge_StartingInputs */



/**
* | output |
* | --- |
* | "Starting now" |
*
* @param {Partner_Customer_Badge_StartingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_badge_starting = /** @type {((inputs?: Partner_Customer_Badge_StartingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Badge_StartingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Startet gerade")
	return /** @type {LocalizedString} */ ("Starting now")
});